import axios from "axios";
import { authHeader } from "./authHeader";

const API_URL = process.env.REACT_APP_API_URL;


const getProducts = (params) => {
    return axios.get(API_URL + '/api/product/', {
        params: params,
        headers: authHeader()
    });
};

const addProduct = async (formData) => {
    const response = await axios.post(API_URL + "/api/product/create", formData, {
        headers: authHeader()
    });
    return response;
};
const confirmProduct = async (formData) => {
    const response = await axios.post(API_URL + "/api/product/confrim", formData, {
        headers: authHeader()
    });
    return response;
};

const updateProduct = async (id, formData) => {
    const response = await axios.put(API_URL + `/api/product//${id}`, formData, {
        headers: authHeader()
    });
    return response;
};

const deleteProduct = async (id) => {
    const response = await axios.delete(API_URL + `/api/product//${id}`, {
        headers: authHeader()
    });
    return response;
};

const getProductsById = async (l_id) => {
    const response = await axios.get(API_URL + `/api/product//${l_id}`, {
        headers: authHeader()
    });
    return response;
};

const PRODUCTAPI = {
  getProducts,
  addProduct,
  updateProduct,
  deleteProduct,
  getProductsById,
  confirmProduct,
};

export default PRODUCTAPI;

